var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { Box, Typography, useTheme } from '@pinwheel/origami';
import CircledX from '../../assets/CircledX';
import useJobFormError from '../hooks/useJobFormError';
import ErrorAction from '../components/Action/ErrorAction';
var style = {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: 0,
    display: 'flex',
    alignItems: 'left',
};
function ActionToAppend(props) {
    return (React.createElement(ErrorAction, { action: __assign(__assign({}, props.action), { label: props.label }), style: style, onSubmit: props.onSubmit }));
}
function Inner(props) {
    var jobFormErrorData = useJobFormError(props.linkApiResponse);
    var errorMessage = jobFormErrorData.errorMessage, actionLabel = jobFormErrorData.actionLabel, accountRecoveryAction = jobFormErrorData.accountRecoveryAction;
    var resolveColor = useTheme().resolveColor;
    var element = useMemo(function () {
        return actionLabel ? (React.createElement(ActionToAppend, { label: actionLabel, action: accountRecoveryAction, onSubmit: props.onSubmit })) : null;
    }, [accountRecoveryAction, actionLabel, props.onSubmit]);
    return (React.createElement(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: {
                type: 'theme',
                colorLegacy: 'Red/20',
                colorNext: 'error/default',
                opacityLegacy: 0.5,
                opacityNext: 0.15,
            },
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '16px',
        }, "data-testid": "provider-formError" },
        React.createElement(CircledX, { size: 32, color: resolveColor({
                type: 'theme',
                colorLegacy: 'Red/50',
                colorNext: 'error/default',
            }) }),
        React.createElement("div", { role: "alert", style: { marginLeft: '8px' } },
            React.createElement(Typography, { variant: "caption", sx: style, color: "light", as: "span" }, errorMessage),
            element)));
}
export default function JobFormError(props) {
    if (props.linkApiResponse.responseType !== 'next_with_error')
        return null;
    return React.createElement(Inner, __assign({}, props));
}
